import { render } from "./TraineeTBSTable.vue?vue&type=template&id=50e09442"
import script from "./TraineeTBSTable.vue?vue&type=script&lang=js"
export * from "./TraineeTBSTable.vue?vue&type=script&lang=js"

import "./TraineeTBSTable.vue?vue&type=style&index=0&id=50e09442&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__